/**
 *
 * key
 *
 */

 const key = 'c291cmNlUmVwb3J0'

 export default key
 